import React, { useState } from "react";
import { Spin as Hamburger } from "hamburger-react";

function HamburgerMenu({ isOpen, setOpen }) {
  return <Hamburger toggled={isOpen} toggle={setOpen} />;
}

export default HamburgerMenu;
